import { keyById } from '@mews/fp';
import { createReducer } from '@mews/framework';
import { RATE_GROUPS_SET } from './actionTypes';

const INITIAL_STATE = {};

export const rateGroupsReducer = createReducer(INITIAL_STATE, {
    // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
    [RATE_GROUPS_SET]: (state, { rateGroups }: $TSFixMe) => ({
        ...state,
        ...keyById(rateGroups),
    }),
});
